<template>
    <Breadcrumb :current="3" />

    <RicercaAuto v-if="mainStore?.type == 'auto'" />
    <RicercaMoto v-else-if="mainStore?.type == 'moto'" />
    <RicercaCom v-else-if="mainStore?.type == 'vcom'" />
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import RicercaAuto from '../components/ricerca-modello/RicercaAuto.vue';
import RicercaMoto from '../components/ricerca-modello/RicercaMoto.vue';
import RicercaCom from '../components/ricerca-modello/RicercaCom.vue';
import { mainStore } from '../../store/main';

export default {
    name: 'RicercaModello',
    components: { Breadcrumb, RicercaAuto, RicercaMoto, RicercaCom },

    data() {
        return {
            mainStore,
        }
    },

    created() {
        if(!this.mainStore?.type) {
            this.$notify({
                title: "Attenzione",
                text: "Selezionare tipo veicolo",
                type: "warn",
            });

            this.$router.push("/scelta-veicolo");
        }

        this.mainStore.perizia = {};
        this.mainStore.perizie = [];
    }
}
</script>